const prodConfig = {
  API_BASE_URL: "https://us-central1-rent-caution.cloudfunctions.net",
  STRIPE_PUBLIC_KEY: "pk_live_51Qtv9pHzUOjnEFmwZt8OPOGLW1bLdz6AkZ9CJOec1pMytW6oYPrlY1mJ3RlmeUFMxE8bR7bQcUrNc17XKoClZJws00EUS64r6j",
  WEB_APP_BASE_URL: "https://fastcaution.app",
  RECAPTCHA_PUBLIC_KEY: "6LfcJ-IqAAAAAHQX30ex8pHNLyc_dTI2386cnPGW",
};

export default prodConfig;